// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {Banner, BannerFlexWrapper} from '../Banner';
import {WorkspaceTemplateMode} from './types';

export const WorkspaceTemplateErrorBanner = ({
  className,
  workspaceTemplateMode,
}: {
  className?: string;
  workspaceTemplateMode: WorkspaceTemplateMode;
}) => {
  return (
    <Banner variant="error" className={twMerge('mb-16', className)}>
      <BannerFlexWrapper>
        <div className="align-center flex text-xs">
          <Icon name="warning" />
        </div>
        <div className="flex-col  text-base">
          <span className="font-semibold">
            Unable to {workspaceTemplateMode} template.
          </span>{' '}
          Please try again.
        </div>
      </BannerFlexWrapper>
    </Banner>
  );
};

export const WorkspaceTemplateInfoBanner = () => {
  return (
    <Banner variant="info" className="my-16">
      <BannerFlexWrapper>
        <div className="align-center flex text-xs">
          <Icon name="lightboard" />
        </div>
        <div className="flex-col  text-base">
          <span className="font-semibold">Auto-apply to new workspaces.</span>{' '}
          Once updated, these will be the default settings in your future
          personal workspaces.
        </div>
      </BannerFlexWrapper>
    </Banner>
  );
};
